import Highlighter from "react-highlight-words";

interface MatchHighlighterProps {
  text: string;
  highlight?: string[];
}

const MatchHighlighter = ({ text, highlight = [] }: MatchHighlighterProps) => {
  // OM returns the full string with an <em> tag wrapping the part we care about, remove all of this
  const mappedParts = highlight.map((markup) => markup.match(/<em>(.*?)<\/em>/)?.[1] ?? "");

  return (
    <Highlighter
      autoEscape
      highlightClassName="highlight"
      searchWords={mappedParts}
      textToHighlight={text}
    />
  );
};

export default MatchHighlighter;
